import React, { lazy } from 'react'
import { createBrowserRouter,Navigate } from 'react-router-dom'

import MainLayout from '@/layouts/Layout'
import Users from '@/pages/users/page'
import Login from '@/pages/login/page'
import Products from '@/pages/products/page'
import Activities from '@/pages/activities/page'
import Claims from '@/pages/claims/page'
import SupplyProducts from '@/pages/supplyProducts/page'
import Account from '@/pages/account/page'
import Merchant from "@/pages/merchant/page"
import Channel from "@/pages/channel/page"
import ActivityProduct from '@/pages/activities/components/activityProduct'
import NotFound from '@/pages/NotFound/page'
import AfterSales from '@/pages/afterSales/page'
import DataBoard from '@/pages/dataBoard/page'
import CustomerService from '@/pages/customerService/page'

const routes = [
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/main',
    element: <MainLayout />,
    children: [
      {
        path: '',
        element: <DataBoard />,
      },
      {
        path: '/main/user',
        element: <Users />,
      },
      {
        path: '/main/products',
        element: <Products />,
      },
      {
        path: '/main/supplyProducts',
        element: <SupplyProducts />,
      },
      {
        path: '/main/activities',
        element: <Activities />,
      },
      {
        path: '/main/claims',
        element: <Claims />,
      },
      {
        path: '/main/account',
        element: <Account />,
      },
      {
        path: '/main/merchant',
        element: <Merchant />,
      },
      {
        path: '/main/channel',
        element: <Channel />,
      },
      {
        path: '/main/activityProducts/:id',
        element: <ActivityProduct />
      },
      {
        path: '/main/afterSales',
        element: <AfterSales />
      },
      {
        path: '/main/customerService',
        element: <CustomerService /> 
      },
      {
        path: '*', 
        element: <NotFound />,
      },
    ],
  },
  {
    path: '*', 
    element: <NotFound />,
  },
]

const router = createBrowserRouter(routes)

export const route = routes

export default router

export const LOGIN_PATHNAME = '/'
export const MAIN_PATHNAME = '/main'
